import PropTypes from 'prop-types';
import { FormHelperText, makeStyles } from '@material-ui/core';
import CycleStep from './cycleStep';
import { STEP_GLOBAL_FIELDS } from '../../../constants/cycle';
import { replaceObjectInList, getItemIndex } from '../../../utility/helpers';

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    fontFamily: 'ProximaNova-Bold',
    fontSize: 18,
    lineHeight: '20px',
    marginBottom: spacing(4),
  },
  steps: {
    display: 'grid',
    gap: 4,
  },
}));

const CycleStepsField = ({
  translations,
  steps,
  settingsValue,
  settingsKey,
  values,
  errors,
  hasError = false,
  errorMessage = '',
  onValidate,
  onResetSettings,
  onSelect,
  onChange,
}) => {
  const classes = useStyles();

  const handleStepSelect = currentStep => () => {
    if (currentStep.isActive && settingsValue?.main !== currentStep.id) {
      onSelect(settingsKey, {
        ...settingsValue,
        main: currentStep.id,
        sub: null,
      });
    }
  };

  const handleToggleStep = currentStep => isChecked => {
    const stepIndex = getItemIndex(steps, currentStep.id);
    const updatedStep = {
      ...currentStep,
      isActive: isChecked,
    };
    const updatedSteps = replaceObjectInList(steps, stepIndex, updatedStep);
    onResetSettings(updatedStep);
    onValidate(updatedSteps);
    onChange(updatedSteps);
  };

  return (
    <div className={classes.root}>
      <FormHelperText classes={{ root: classes.label }}>
        {translations.label}
      </FormHelperText>
      <div className={classes.steps}>
        {steps.map(step => (
          <CycleStep
            key={`step_item_${step.id}`}
            translations={translations}
            step={step}
            startAt={values?.[step.id]?.[STEP_GLOBAL_FIELDS.START_AT]}
            endAt={values?.[step.id]?.[STEP_GLOBAL_FIELDS.END_AT]}
            error={errors?.[step.id]}
            errorMessage={translations.error}
            isSelected={settingsValue?.main === step.id}
            onSelect={handleStepSelect(step)}
            onToggleStep={handleToggleStep(step)}
          />
        ))}
      </div>
      {hasError && errorMessage && (
        <FormHelperText error={hasError}>{errorMessage}</FormHelperText>
      )}
    </div>
  );
};

CycleStepsField.propTypes = {
  translations: PropTypes.object.isRequired,
  steps: PropTypes.arrayOf(PropTypes.object).isRequired,
  settingsValue: PropTypes.object.isRequired,
  settingsKey: PropTypes.string.isRequired,
  errors: PropTypes.object.isRequired,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  onValidate: PropTypes.func.isRequired,
  onResetSettings: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default CycleStepsField;
